<template>
    <div style="width:94%; margin-left:3%; height:330px; border: 1px solid #E0E0E0;">
        <table style="width:100%">
            <tr style="height:50px;">
                <td style="width:10px; background:#5DC0FF;"></td>
                <td style="width:80px;">
                    <div style="text-align: left; font-size: 16px; font-weight: bold; color:black;">工单信息</div>
                </td>
                <td>
                    <div style="text-align: left; font-size: 12px; font-weight: bold; color:gray;">工单编号：{{no}}</div>
                </td>
                <td></td>
                <td>
                    <div style="text-align: right; font-size: 12px; font-weight: bold; color:gray;">运行效率：</div>
                </td>
                <td>
                    <div style="text-align: right; font-size: 16px; font-weight: bold; color:black;">{{efficiency}}%</div>
                </td>
            </tr>
        </table>
        <table border="1" style="width:100%">
            <tr>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/beltBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>皮带流程</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 18px; font-weight: bold; color:black;text-align:center;">{{belt}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/berthBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>泊位</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 18px; font-weight: bold; color:black;text-align:center;">{{berth}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/areaBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>堆场</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 18px; font-weight: bold; color:black;text-align:center;">{{area}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/typeBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>操作类型</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 18px; font-weight: bold; color:black;text-align:center;">{{type}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/numberBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>操作量</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 18px; font-weight: bold; color:black;text-align:center;">{{number}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/beginTimeBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>开始时间</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 14px; font-weight: bold; color:black;text-align:center;">{{beginTime}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/durationBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>运行时间</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 14px; font-weight: bold; color:black;text-align:center;">{{duration}}</td>
                        </tr>
                    </table>
                </td>
                <td style="width:25%">
                    <table style="width:100%">
                        <tr>
                            <td><center><img width="55" :src="getImg('/projectDingZhi/ningbo/energyBg.png')"></center></td>
                        </tr>
                        <tr>
                            <td><center>累计电耗</center></td>
                        </tr>
                        <tr style="height:40px;">
                            <td style="font-size: 14px; font-weight: bold; color:red;text-align:center;">{{energy}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import XLSX from 'xlsx'

export default {
    components:{
    },
    data(){
        return{
        }
    },
    computed:{
        no(){
            return this.$store.ningboStore.getters.getWorkorder.no;
        },
        belt(){
            return this.$store.ningboStore.getters.getWorkorder.belt;
        },
        berth(){
            return this.getBerth(this.$store.ningboStore.getters.getWorkorder.berthId);
        },
        area(){
            return this.getArea(this.$store.ningboStore.getters.getWorkorder.areaId);
        },
        type(){
            return this.getType(this.$store.ningboStore.getters.getWorkorder.typeId, this.$store.ningboStore.getters.getWorkorder.number);
        },
        number(){
            return this.$store.ningboStore.getters.getWorkorder.number + 'T'
        },
        beginTime(){
            return new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).format('yyyy-MM-dd hh:mm:ss');
        },
        duration(){
            if(this.$store.ningboStore.getters.getWorkorder.runState == 2){
                return this.formatDuration(new Date(this.$store.ningboStore.getters.getWorkorder.endTime).getTime() - new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).getTime());
            }else{
                return this.formatDuration(new Date().getTime() - new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).getTime());
            }
        },
        energy(){
            return this.$store.ningboStore.getters.getWorkorder.energy + 'KWH'
        },
        efficiency(){
            return this.$store.ningboStore.getters.getWorkorder.efficiency;
        },
        berthList(){
            return this.$store.ningboStore.getters.getBerthList;
        },
        areaList(){
            return this.$store.ningboStore.getters.getAreaList;
        },
        typeList(){
            return this.$store.ningboStore.getters.getTypeList;
        }
    },
    mounted(){
    },
    watch:{
    },
    methods:{
        getBerth(berthId){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == berthId){
                    return this.berthList[i].name;
                }
            }
            return berthId
        },
        getArea(areaId){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == areaId){
                    return this.areaList[i].name;
                }
            }
            return areaId
        },
        getType(typeId, number){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == typeId){
                    return this.typeList[i].name;// + ':' + number + 'T';
                }
            }
            return typeId;// + ':' + number
        },
        formatBeginTime (row, column) {
            return new Date(eval('row.' + column.property)).format('yyyy-MM-dd hh:mm:ss');
        },
        formatBert(row, column){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == row.berthId){
                    return this.berthList[i].name;
                }
            }
            return row.berthId
        },
        formatArea(row, column){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == row.areaId){
                    return this.areaList[i].name;
                }
            }
            return row.areaId
        },
        formatType(row, column){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == row.typeId){
                    return this.typeList[i].name + ':' + row.number + 't';
                }
            }
            return row.typeId + ':' + row.number
        },
        formatState(row, column){
            if(row.runState == 0){
                return '运行中'
            }else if(row.runState == 1){
                return '暂停'
            }else if(row.runState == 2){
                return '结束'
            }else{
                return 'N/A'
            }
        },
        formatDuration(duration){
            duration /= 1000;
            var day = parseInt(duration / (60 * 60 * 24));
            duration -= day * (60 * 60 * 24);
            var hour = parseInt(duration / (60 * 60));
            duration -= hour * (60 * 60);
            var minute = parseInt(duration / 60);
            var second = duration - minute * 60;

            var str = '';
            if(day > 0){
                str = day + '天'
            }
            str += hour + '小时' + minute + '分' + parseInt(second) + '秒'
            return str;
        },
        getImg(path){
            var p = this.$store.resourcesStore.getters.getResourcesByName(path);
            return p;
        },
    }
}
</script>
<style scoped>
</style>